import { connectorDisplayName, type ConnectorStatus } from './connectors';

// The connectors page BI identity, in its own tiny module so both the connectors controllers
// (lib/use-connectors.ts) and the reusable connect action (lib/use-connect-connector.ts) can read it
// without a circular import between them. Re-exported from lib/use-connectors.ts, which is where every
// component still imports it from.
export const CONNECTORS_PAGE = { page_name: 'connectors' as const, page_version: 'v1_connectors' as const };

/** `additionalFields` for a Connect / Add-account tap on the connectors page — which connector was tapped:
 *  `toolkit` (the stable slug) and `connector_name` (the name the row shows). A row we can't resolve still
 *  reports its slug. Same keys as native `SymphonyBi.connectorClickFields`. */
export const connectorClickFields = (connector: ConnectorStatus | undefined, toolkit?: string): Record<string, string | undefined> => ({
  toolkit: connector?.toolkit || toolkit,
  connector_name: connector ? connectorDisplayName(connector) : undefined,
});
